import { useState, useEffect } from "react";
import cx from "classnames";
import { createPopper } from "@popperjs/core";
import PropTypes from "prop-types";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import Filter from "../Filter/Filter";
import Icon from "../../components/Icon/Icon";
import CaretUp from "../../icons/caret-up.svg";
import CaretDown from "../../icons/caret-down.svg";
import styles from "./DropDown.module.scss";

const DropDown = ({
  t,
  isOpen,
  name,
  dropDownErrorClass,
  selected,
  className,
  onToggle,
  onSave,
  buttonText,
  ...nextProps
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggle = () => {
    onToggle && onToggle(!isDropdownOpen, name);
    setIsDropdownOpen((prevState) => !prevState);
  };
  const save = () => {
    onSave && onSave();
    toggle();
  };

  useEffect(() => {
    const reference = document.querySelector(`.toggle${name}`);
    const popper = document.querySelector(`#dropdown-menu${name}`);
    createPopper(reference, popper, {
      placement: "top",
      modifiers: {
        applyStyle: { enabled: false },
        applyReactStyle: {
          enabled: true,
          order: 800,
        },
      },
    });
  }, []);

  useEffect(() => {
    setIsDropdownOpen(isOpen);
  }, [isOpen]);

  const labelClassName =
    selected && selected.length ? styles.labelValue : styles.labelName;

  return (
    <Dropdown
      isOpen={isDropdownOpen}
      toggle={toggle}
      className={cx(styles.dropDown, className)}
    >
      <DropdownToggle
        className={cx(
          styles.toggle,
          { [styles.toggleOpen]: isDropdownOpen },
          `toggle${name}`,
          "toggle",
          dropDownErrorClass
        )}
      >
        <span className={labelClassName}>{buttonText}</span>
        <Icon
          name={!isDropdownOpen ? CaretDown : CaretUp}
          className={styles.iconCaret}
        />
      </DropdownToggle>
      <DropdownMenu
        className={cx(styles.dropDownPanel)}
        id={`dropdown-menu${name}`}
      >
        <Filter name={name} selected={selected} onSave={save} {...nextProps} />
      </DropdownMenu>
    </Dropdown>
  );
};

DropDown.propTypes = {
  option: PropTypes.array,

  name: PropTypes.string,
  onToggle: PropTypes.func,
  isSearchInput: PropTypes.bool,
  onClear: PropTypes.func,
  selected: PropTypes.array,
  onSave: PropTypes.func,
};

export default DropDown;
